import React from "react";
import { Spacer, Input } from '@nextui-org/react';

const MoreInformation = ({
  setMoreInformationToState,
  customFields,
  userText1,
  userText2,
  userText3,
  UserDate1,
  UserDate2,
  UserDate3,
  UserNum1,
  UserNum2,
  UserNum3
}) => {
  const inputStyles = {
    css: { 
      $$inputBorderRadius: "0.375rem", 
      flexGrow: 1, 
      h: 40, 
      mt: 2,
      backgroundColor: "white",
      "&:hover": {
        borderColor: "hsl(var(--p))"
      }
    },
    shadow: false,
    bordered: true,
    rounded: true,
    classNames: {
      input: "text-sm",
      label: "text-sm font-medium text-gray-700"
    }
  };

  const labelStyles = "text-sm font-medium text-gray-700 mb-1";
  const gridStyles = "grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4 p-4 bg-base-100 rounded-lg shadow-sm";

  const renderInput = (label, type, placeholder, value, field) => (
    <div className="form-control w-full">
      <label className={labelStyles}>{label}</label>
      <Input
        type={type}
        placeholder={placeholder}
        clearable={type === 'text'}
        onChange={(e) => setMoreInformationToState("moreInformation", field, e.target.value)}
        value={value}
        {...inputStyles}
      />
    </div>
  );

  const renderCustomFields = () => {
    const fields = [
      // Text fields
      { label: customFields.usr_text1_lbl, type: 'text', value: userText1, field: 'userText1' },
      { label: customFields.usr_text2_lbl, type: 'text', value: userText2, field: 'userText2' },
      { label: customFields.usr_text3_lbl, type: 'text', value: userText3, field: 'userText3' },
      // Date fields
      { label: customFields.usr_date1_lbl, type: 'date', value: UserDate1, field: 'UserDate1' },
      { label: customFields.usr_date2_lbl, type: 'date', value: UserDate2, field: 'UserDate2' },
      { label: customFields.usr_date3_lbl, type: 'date', value: UserDate3, field: 'UserDate3' },
      // Number fields
      { label: customFields.usr_num1_lbl, type: 'number', value: UserNum1, field: 'UserNum1' },
      { label: customFields.usr_num2_lbl, type: 'number', value: UserNum2, field: 'UserNum2' },
      { label: customFields.usr_num3_lbl, type: 'number', value: UserNum3, field: 'UserNum3' }
    ];

    return fields.map((field, index) => 
      field.label && (
        <div key={index}>
          {renderInput(
            field.label,
            field.type,
            `Enter ${field.label}`,
            field.value,
            field.field
          )}
        </div>
      )
    );
  };

  const hasCustomFields = () => {
    return Object.values(customFields).some(value => value);
  };

  if (!hasCustomFields()) {
    return null;
  }

  return (
    <div className="space-y-4 p-4 bg-base-200 rounded-xl">
      <div className={gridStyles}>
        {renderCustomFields()}
      </div>
    </div>
  );
};

export default MoreInformation;